"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FeToggle = function FeToggle(props) {
  var className = (0, _classnames.default)('fe-toggle', props.className);
  var toggleProps = Object.assign({}, props);
  delete toggleProps.size;
  delete toggleProps.className;
  return _react.default.createElement("label", {
    className: className,
    htmlFor: props.id
  }, _react.default.createElement("input", _extends({}, toggleProps, {
    type: "checkbox",
    className: "fe-toggle__checkbox"
  })), _react.default.createElement("span", {
    className: "".concat((0, _classnames.default)('fe-toggle__btn', {
      'fe-toggle__btn--sm': props.size === 'small'
    }))
  }));
};

FeToggle.defaultProps = {
  id: null,
  size: 'regular'
};
FeToggle.propTypes = {
  /** Provide id attribute for toggle*/
  id: _propTypes.default.string.isRequired,

  /** Provide size for toggle like 'regular' or 'small'*/
  size: _propTypes.default.oneOf(['regular', 'small'])
};
FeToggle.displayName = 'FeToggle';
var _default = FeToggle;
exports.default = _default;